export default "__VITE_ASSET__DqBCQLPc__"